import moment from "moment";
import Vue from 'vue';
import ReportsService from '@/services/ReportsService';
import ReportsServiceV2 from '@/services/ReportsService-v2';
import { router } from '@/router';
import store from '@/store'

function initialState() {
    return {
        AggregatordailySalesReportV2: {},
        AggregatordailyReportsList: [],
        AggregatordailyRefundsList: [],
        AggregatordailyConcessionReportsList: [],
        AggregatordailyExcelFileName: null,
        AggregatordailyPDFFileName: null,
        flag: {
            isCinema: false,
            isExcelDownload: false,
        },
        AggregatordailyReportsObject: {
            fromDate: new Date(),
            toDate: new Date(),
            cinema_id: null,
            user_id: null,
            pm_id: null,

            // Show Selected Name Only
            cinema_name: "",
            username: "",
            pm_payment_mode: "",
            // THIS IS FOR FUTURE
            // offers_voucher_id: null,
            // offer_voucher_type: ""
        },
        // TOTALS
        boxOfficeTotal: {
            totalNumberOfTickets: 0,
            totalNetRevenue: 0,
            totalGrossRevenue: 0,
        },
        concessionOfficeTotal: {
            totalNumberOfTickets: 0,
            totalNetRevenue: 0,
            totalGrossRevenue: 0,
        },
        grandTotal: {
            totalNumberOfTickets: 0,
            totalNetRevenue: 0,
            totalGrossRevenue: 0,
            totalDiscount: 0,
        },
        // PAYMENT SUMMARY
        paymentSummary: [],
        filmWiseSummary: [],
        UserWiseSummary: [],
        RefundSummary: [],

        paging: {},
    }
};

const state = initialState();

const mutations = {
    ON_RESET_DAILY_SALES_REPORT_STORE_STATE: (state, payload) => {
        // state = initialState();
        const s = initialState()
        Object.keys(s).forEach(key => {
            state[key] = s[key]
        })
    },
    SET_DAILY_REPORT_LIST: (state, payload) => {
        state.AggregatordailyReportsList = payload;
        console.log('dailyReportsList :', state.AggregatordailyReportsList);

    },
    SET_DAILY_REFUND_LIST: (state, payload) => {
        state.AggregatordailyRefundsList = payload;
        console.log('dailyReportsList2 :', state.AggregatordailyRefundsList);

    },
    SET_DAILY_CONCESSION_REPORT_LIST: (state, payload) => {
        state.AggregatordailyConcessionReportsList = payload;
    },
    SET_DAILY_PAYMENT_SUMMARY_LIST: (state, payload) => {
        state.paymentSummary = payload;
    },
    SET_DAILY_FILM_SUMMARY_LIST: (state, payload) => {
        state.filmWiseSummary = payload;
    },
    SET_DAILY_USER_SUMMARY_LIST: (state, payload) => {
        state.UserWiseSummary = payload;
    },
    SET_DAILY_REFUND_SUMMARY_LIST: (state, payload) => {
        state.RefundSummary = payload;
    },
    SET_DAILY_GRAND_V2_TOTAL: (state, payload) => {

        if (payload && payload.length > 0) {
            let countedNames = payload.reduce((acc, obj, index1) => {
                if (index1 == 0) {
                    acc.grandTotal.totalDiscount = 0
                }
                let Tickets = obj.DataRefund ? obj.Data.reduce(function (accumulator, { tickets }) { return accumulator + parseFloat(tickets); }, 0) - obj.DataRefund.reduce(function (accumulator, { tickets }) { return accumulator + parseFloat(tickets); }, 0) : obj.Data.reduce(function (accumulator, { tickets }) { return accumulator + parseFloat(tickets); }, 0)
                let NetRevenue = obj.DataRefund ? obj.Data.reduce(function (accumulator, { net_revenue }) { return accumulator + parseFloat(net_revenue); }, 0) - obj.DataRefund.reduce(function (accumulator, { net_revenue }) { return accumulator + parseFloat(net_revenue); }, 0) : obj.Data.reduce(function (accumulator, { net_revenue }) { return accumulator + parseFloat(net_revenue); }, 0)
                let GrossRevenue = obj.DataRefund ? obj.Data.reduce(function (accumulator, { gross_revenue }) { return accumulator + parseFloat(gross_revenue); }, 0) - obj.DataRefund.reduce(function (accumulator, { gross_revenue }) { return accumulator + parseFloat(gross_revenue); }, 0) : obj.Data.reduce(function (accumulator, { gross_revenue }) { return accumulator + parseFloat(gross_revenue); }, 0)
                let Discount = obj.DataRefund ? obj.Data.reduce(function (accumulator, { discount }) { return accumulator + parseFloat(discount); }, 0) - obj.DataRefund.reduce(function (accumulator, { discount }) { return accumulator + parseFloat(discount); }, 0) : obj.Data.reduce(function (accumulator, { discount }) { return accumulator + parseFloat(discount); }, 0)
                // acc.boxOfficeTotal.totalNumberOfTickets += Tickets;
                // acc.boxOfficeTotal.totalNetRevenue += NetRevenue;
                // acc.boxOfficeTotal.totalGrossRevenue += GrossRevenue;
                // GRAND TOTAL:
                console.log('Discount :', Discount, acc.grandTotal);
                // if (acc.grandTotal.totalDiscount == NaN) {
                //     acc.grandTotal.totalDiscount = 0
                // }
                // console.log('Discount :', Discount, acc.grandTotal);

                // console.log('acc.grandTotal.totalNumberOfTickets :', acc.grandTotal.totalDiscount);

                acc.grandTotal.totalNumberOfTickets += Tickets;
                acc.grandTotal.totalNetRevenue += NetRevenue;
                acc.grandTotal.totalGrossRevenue += GrossRevenue;
                acc.grandTotal.totalDiscount = Discount + acc.grandTotal.totalDiscount;

                // console.log('Discount :', Discount, acc.grandTotal);

                return acc;
            }, { grandTotal: state.grandTotal });
        };
    },
    SET_DAILY_GRAND_TOTAL: (state, payload) => {

        if (payload && payload.length > 0) {
            let countedNames = payload.reduce((acc, obj) => {
                if (obj.hasOwnProperty('payments') && obj.payments.length > 0) {
                    let Tickets = obj.payments.reduce(function (accumulator, { total_seats }) { return accumulator + parseFloat(total_seats); }, 0);
                    let NetRevenue = obj.payments.reduce(function (accumulator, { net_revenue }) { return accumulator + parseFloat(net_revenue); }, 0);
                    let GrossRevenue = obj.payments.reduce(function (accumulator, { gross_revenue }) { return accumulator + parseFloat(gross_revenue); }, 0);
                    acc.boxOfficeTotal.totalNumberOfTickets += Tickets;
                    acc.boxOfficeTotal.totalNetRevenue += NetRevenue;
                    acc.boxOfficeTotal.totalGrossRevenue += GrossRevenue;
                    // GRAND TOTAL:
                    acc.grandTotal.totalNumberOfTickets += Tickets;
                    acc.grandTotal.totalNetRevenue += NetRevenue;
                    acc.grandTotal.totalGrossRevenue += GrossRevenue;
                } else if (obj.hasOwnProperty('transactions') && obj.transactions.length > 0) {
                    let Tickets = obj.transactions.reduce(function (accumulator, { number_of_tickets }) { return accumulator + parseFloat(number_of_tickets); }, 0);
                    let NetRevenue = obj.transactions.reduce(function (accumulator, { net_revenue }) { return accumulator + parseFloat(net_revenue); }, 0);
                    let GrossRevenue = obj.transactions.reduce(function (accumulator, { gross_revenue }) { return accumulator + parseFloat(gross_revenue); }, 0);

                    acc.concessionOfficeTotal.totalNumberOfTickets += Tickets;
                    acc.concessionOfficeTotal.totalNetRevenue += NetRevenue;
                    acc.concessionOfficeTotal.totalGrossRevenue += GrossRevenue;

                    // GRAND TOTAL:
                    acc.grandTotal.totalNumberOfTickets += Tickets;
                    acc.grandTotal.totalNetRevenue += NetRevenue;
                    acc.grandTotal.totalGrossRevenue += GrossRevenue;
                };

                return acc;
            }, { boxOfficeTotal: state.boxOfficeTotal, concessionOfficeTotal: state.concessionOfficeTotal, grandTotal: state.grandTotal });
        };
    },
    ON_RESET_TOTALS: (state, payload) => {
        state.boxOfficeTotal = {
            totalNumberOfTickets: 0,
            totalNetRevenue: 0,
            totalGrossRevenue: 0,
        };
        state.concessionOfficeTotal = {
            totalNumberOfTickets: 0,
            totalNetRevenue: 0,
            totalGrossRevenue: 0,
        };
        state.grandTotal = {
            totalNumberOfTickets: 0,
            totalNetRevenue: 0,
            totalGrossRevenue: 0,
        };
    },
    SET_DAILY_EXCEL_FILE_NAME: (state, payload) => {
        state.AggregatordailyExcelFileName = payload;
    },
    SET_DAILY_SALES_REPORT: (state, payload) => {
        state.AggregatordailySalesReportV2 = payload;
    },
    SET_DAILY_PDF_FILE_NAME: (state, payload) => {
        state.AggregatordailyPDFFileName = payload;
    },
    SET_DAILY_REPORT_DATES: (state, payload) => {
        // payload['name'] ? state.dailyReportsObject[payload.name] = payload['event'] ? payload.event : null : '';
        payload['name'] ? state.AggregatordailyReportsObject['fromDate'] = payload['event'] ? payload.event : null : '';
        payload['name'] ? state.AggregatordailyReportsObject['toDate'] = payload['event'] ? payload.event : null : '';
    },
    SET_DAILY_REPORT_DROPDOWN: (state, payload) => {
        if (state.AggregatordailyReportsList.length > 0) {
            state.AggregatordailyReportsList = [];
            state.AggregatordailyConcessionReportsList = [];
        }
        switch (payload.name) {
            case 'Cinema':
                state.AggregatordailyReportsObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.AggregatordailyReportsObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                if (state.AggregatordailyReportsObject.cinema_id) {
                    store.dispatch('fetchPosUsersList', { cinema_id: state.AggregatordailyReportsObject.cinema_id })
                }
                break;

            case 'AggregatorUser':
                state.AggregatordailyReportsObject.user_id = payload['selectedItem'] ? payload.selectedItem.user_id : null;
                state.AggregatordailyReportsObject.username = payload['selectedItem'] ? !payload.selectedItem.user_id ? 'All' : `${payload.selectedItem.first_name} ${payload.selectedItem.middle_name} ${payload.selectedItem.last_name}` : null;
                break;
            case 'PaymentMode':
                state.AggregatordailyReportsObject.pm_id = payload['selectedItem'] ? payload.selectedItem.pm_id : null;
                state.AggregatordailyReportsObject.pm_payment_mode = payload['selectedItem'] ? payload.selectedItem.pm_payment_mode : null;
                break;
            // case 'OfferVoucher':
            //     state.dailyReportsObject.offers_voucher_id = payload['selectedItem'] ? payload.selectedItem.offers_voucher_id : null;
            //     state.dailyReportsObject.offer_voucher_type = payload['selectedItem'] ? payload.selectedItem.offer_voucher_type : null;
            //     break;
            default:
                console.log('Sorry, we are enable to set value.');
        }
    },
    SET_DAILY_REPORT_FLAG: async (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.flag.isCinema = payload['value'] ? String(payload.value).length === 0 ? false : true : false;
                state.AggregatordailyReportsObject.cinema_id = payload['value'] && String(payload.value).length === 0 ? null : payload.value;
                if (state.AggregatordailyReportsObject.cinema_id) {
                    store.dispatch('fetchPosUsersList', { cinema_id: state.AggregatordailyReportsObject.cinema_id })
                }
                break;
            case 'isExcelDownload':
                if (state.AggregatordailyExcelFileName && state.AggregatordailyExcelFileName.length > 0) {
                    store.dispatch("globalRemoveFile", { fileName: state.dailyExcelFileName });
                };
                if (state.AggregatordailyPDFFileName && state.AggregatordailyPDFFileName.length > 0) {
                    store.dispatch("globalRemoveFile", { fileName: state.AggregatordailyPDFFileName });
                };
                state.AggregatordailyPDFFileName = null;
                state.AggregatordailyExcelFileName = null;
                break;
            default:
                console.log('Sorry, we are enable to set Flag.');
        }
    }
}

const actions = {
    onResetDailyReportStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
        await commit('ON_RESET_DAILY_SALES_REPORT_STORE_STATE');
    },
    fetchDailyReportList: async ({ dispatch, commit, state }, payload) => {
        state.dailyExcelFileName ? store.dispatch("globalRemoveFile", { fileName: state.dailyExcelFileName }) : '';
        state.dailyPDFFileName ? store.dispatch("globalRemoveFile", { fileName: state.dailyPDFFileName }) : '';
        // console.log('object :', state.dailyReportsObject.fromDate, state.dailyReportsObject.toDate);
        // console.log('1 :', state.dailyReportsObject.fromDate >= new Date() && state.dailyReportsObject.toDate >= new Date());
        // console.log('2 :', state.dailyReportsObject.fromDate >= new Date());
        // console.log('3 :', state.dailyReportsObject.toDate >= new Date());
        // console.log('4 :', new Date(state.dailyReportsObject.fromDate) > new Date(state.dailyReportsObject.toDate));
        // console.log('4 :', new Date(state.dailyReportsObject.fromDate), new Date(state.dailyReportsObject.toDate));
        let fromDate = moment(new Date(state.dailyReportsObject.fromDate)).format("YYYY-MM-DD");
        let toDate = moment(new Date(state.dailyReportsObject.toDate)).format("YYYY-MM-DD");

        // console.log('object :', new Date(fromDate) > new Date(toDate));
        // console.log('object 2 :', new Date(fromDate), new Date(toDate));

        if (new Date(fromDate) >= new Date() && new Date(toDate) >= new Date()) {
            Vue.toasted.show("From date and To date should not be greater than the current date.");
        } else if (new Date(fromDate) >= new Date()) {
            Vue.toasted.show("From date should not be greater than the current date.");
        } else if (new Date(toDate) >= new Date()) {
            Vue.toasted.show("To date should not be greater than the current date.");
        } else if (new Date(fromDate) > new Date(toDate)) {
            Vue.toasted.show("From date should not be greater than To date.");
        } else if (!state.dailyReportsObject.cinema_id) {
            Vue.toasted.show("Please Select any Cinema.");
        }
        // NOT CHECKING STRICTLY
        // else if (!state.dailyReportsObject.user_id) {
        //     Vue.toasted.show("Please Select any user.");
        // } else if (!state.dailyReportsObject.pm_id) {
        //     Vue.toasted.show("Please Select any Payment Mode.");
        // }
        // THIS IS FOR FUTURE
        // else if (!state.dailyReportsObject.offers_voucher_id) {
        //     Vue.toasted.show("Please Select any Offer Voucher.");
        // }
        else {
            let loader = Vue.$loading.show()

            await commit('SET_DAILY_REPORT_LIST', []);
            await commit('SET_DAILY_CONCESSION_REPORT_LIST', []);
            await commit('SET_DAILY_PDF_FILE_NAME', null);
            await commit('SET_DAILY_EXCEL_FILE_NAME', null);
            await commit('ON_RESET_TOTALS', null)
            await commit('SET_DAILY_PAYMENT_SUMMARY_LIST', [])
            await commit('SET_DAILY_FILM_SUMMARY_LIST', []);
            await commit('SET_DAILY_USER_SUMMARY_LIST', []);
            await commit('SET_DAILY_REFUND_SUMMARY_LIST', []);
            state.dailyReportsObject["fromDate"]=moment(state.dailyReportsObject["fromDate"]).format('YYYY-MM-DD')
            state.dailyReportsObject["toDate"]=moment(state.dailyReportsObject["toDate"]).format('YYYY-MM-DD')

            ReportsService.GetDailyReportList(state.dailyReportsObject)
                .then(async (response) => {
                    const { data } = response;
                    if (data && data.status) {

                        // await commit('SET_DAILY_REPORT_V2', data || []);

                        if (data.Records.length > 0) {
                            await commit('SET_DAILY_REPORT_LIST', data.Records || []);
                        };
                        // if (data.ConcessionFinalResults.length > 0) {
                        //     await commit('SET_DAILY_CONCESSION_REPORT_LIST', data.ConcessionFinalResults || [])
                        // };
                        // if (data['paymentSummary'] && data.paymentSummary.length > 0) {
                        //     await commit('SET_DAILY_PAYMENT_SUMMARY_LIST', data.paymentSummary)
                        // };
                        // if (data['FilmWiseSummary'] && data.FilmWiseSummary.length > 0) {
                        //     await commit('SET_DAILY_FILM_SUMMARY_LIST', data.FilmWiseSummary);
                        // };
                        // if (data['UserWiseSummary'] && data.UserWiseSummary.length > 0) {
                        //     await commit('SET_DAILY_USER_SUMMARY_LIST', data.UserWiseSummary);
                        // };
                        // if (data['RefundSummary'] && data.RefundSummary.length > 0) {
                        //     await commit('SET_DAILY_REFUND_SUMMARY_LIST', data.RefundSummary);
                        // };


                        // await commit('SET_DAILY_GRAND_TOTAL', [...data.Records, ...data.ConcessionFinalResults])
                        await commit('SET_DAILY_EXCEL_FILE_NAME', data.Excel || null);
                        await commit('SET_DAILY_PDF_FILE_NAME', data.PDFName || null);
                    } else Vue.toasted.show(data.message || 'Opps! Something went wrong');
                }).catch((error) => {
                    Vue.toasted.show("Catch Error on ReportStore fetchDailyReportList", error);
                }).finally(() => {
                    setTimeout(() => loader.hide(), 1000);
                });;
        }
    },
    fetchAggregatorDailyReportListv2: async ({ dispatch, commit, state }, payload) => {
        state.AggregatordailyExcelFileName ? store.dispatch("globalRemoveFile", { fileName: state.AggregatordailyExcelFileName }) : '';
        state.AggregatordailyPDFFileName ? store.dispatch("globalRemoveFile", { fileName: state.AggregatordailyPDFFileName }) : '';
        // console.log('object :', state.dailyReportsObject.fromDate, state.dailyReportsObject.toDate);
        // console.log('1 :', state.dailyReportsObject.fromDate >= new Date() && state.dailyReportsObject.toDate >= new Date());
        // console.log('2 :', state.dailyReportsObject.fromDate >= new Date());
        // console.log('3 :', state.dailyReportsObject.toDate >= new Date());
        // console.log('4 :', new Date(state.dailyReportsObject.fromDate) > new Date(state.dailyReportsObject.toDate));
        // console.log('4 :', new Date(state.dailyReportsObject.fromDate), new Date(state.dailyReportsObject.toDate));
        let fromDate = moment(new Date(state.AggregatordailyReportsObject.fromDate)).format("YYYY-MM-DD");
        // let toDate = moment(new Date(state.dailyReportsObject.toDate)).format("YYYY-MM-DD");

        // console.log('object :', new Date(fromDate) > new Date(toDate));
        // console.log('object 2 :', new Date(fromDate), new Date(toDate));

        // if (new Date(fromDate) >= new Date() && new Date(toDate) >= new Date()) {
        //     Vue.toasted.show("From date and To date should not be greater than the current date.");
        // } else if (new Date(fromDate) >= new Date()) {
        //     Vue.toasted.show("From date should not be greater than the current date.");
        // } else if (new Date(toDate) >= new Date()) {
        //     Vue.toasted.show("To date should not be greater than the current date.");
        // } else if (new Date(fromDate) > new Date(toDate)) {
        //     Vue.toasted.show("From date should not be greater than To date.");
        // } else if (!state.dailyReportsObject.cinema_id) {
        //     Vue.toasted.show("Please Select any Cinema.");
        // }
        // NOT CHECKING STRICTLY
        // else if (!state.dailyReportsObject.user_id) {
        //     Vue.toasted.show("Please Select any user.");
        // } else if (!state.dailyReportsObject.pm_id) {
        //     Vue.toasted.show("Please Select any Payment Mode.");
        // }
        // THIS IS FOR FUTURE
        // else if (!state.dailyReportsObject.offers_voucher_id) {
        //     Vue.toasted.show("Please Select any Offer Voucher.");
        // }
        //else {
        let loader = Vue.$loading.show()

        await commit('SET_DAILY_REPORT_LIST', []);
        await commit('SET_DAILY_CONCESSION_REPORT_LIST', []);
        await commit('SET_DAILY_PDF_FILE_NAME', null);
        await commit('SET_DAILY_EXCEL_FILE_NAME', null);
        await commit('ON_RESET_TOTALS', null)
        await commit('SET_DAILY_PAYMENT_SUMMARY_LIST', [])
        await commit('SET_DAILY_FILM_SUMMARY_LIST', []);
        await commit('SET_DAILY_USER_SUMMARY_LIST', []);
        await commit('SET_DAILY_REFUND_SUMMARY_LIST', []);
        state.AggregatordailyReportsObject["fromDate"]=moment(state.AggregatordailyReportsObject["fromDate"]).format('YYYY-MM-DD')
        state.AggregatordailyReportsObject["toDate"]=moment(state.AggregatordailyReportsObject["toDate"]).format('YYYY-MM-DD')

        ReportsServiceV2.GetAggregatorDailyReportList(state.AggregatordailyReportsObject)
            .then(async (response) => {
                const { data } = response;
                console.log('data :', data.data);
                if (data && data.status) {
                    if (data.data.length > 0) {
                        await commit('SET_DAILY_REPORT_LIST', data.data || []);
                    };
                    if (data.data2.length > 0) {
                        await commit('SET_DAILY_REFUND_LIST', data.data2 || []);
                    };
                    if (data.ConcessionFinalResults.length > 0) {
                        await commit('SET_DAILY_CONCESSION_REPORT_LIST', data.ConcessionFinalResults || [])
                    };
                    // if (data['paymentSummary'] && data.paymentSummary.length > 0) {
                    //     await commit('SET_DAILY_PAYMENT_SUMMARY_LIST', data.paymentSummary)
                    // };
                    // if (data['FilmWiseSummary'] && data.FilmWiseSummary.length > 0) {
                    //     await commit('SET_DAILY_FILM_SUMMARY_LIST', data.FilmWiseSummary);
                    // };
                    // if (data['UserWiseSummary'] && data.UserWiseSummary.length > 0) {
                    //     await commit('SET_DAILY_USER_SUMMARY_LIST', data.UserWiseSummary);
                    // };
                    // if (data['RefundSummary'] && data.RefundSummary.length > 0) {
                    //     await commit('SET_DAILY_REFUND_SUMMARY_LIST', data.RefundSummary);
                    // };


                    await commit('SET_DAILY_GRAND_V2_TOTAL', [...data.data])
                    await commit('SET_DAILY_EXCEL_FILE_NAME', data.ExcelName || null);
                    await commit('SET_DAILY_PDF_FILE_NAME', data.PDFName || null);
                } else Vue.toasted.show(data.message || 'Opps! Something went wrong');
            }).catch((error) => {
                Vue.toasted.show("Catch Error on ReportStore fetchDailyReportList", error);
            }).finally(() => {
                setTimeout(() => loader.hide(), 1000);
            });;
        //}
    },

    // On Handlers
    onAggregatorDailyReportDateHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DAILY_REPORT_DATES', payload);
        await commit('SET_DAILY_REPORT_FLAG', { name: 'isExcelDownload', value: false });
    },
    onAggregatorDailyReportDropdownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_DAILY_REPORT_DROPDOWN', payload);
        await commit('SET_DAILY_REPORT_FLAG', { name: 'isExcelDownload', value: false });
    },
    onAggregatorDailyReportFlagHandler({ dispatch, commit, state }, payload) {
        commit('SET_DAILY_REPORT_FLAG', payload);
    },
}

const getters = {
    // THIS IS FOR FUTURE
    // getDailyReportSelectedOfferVoucher: state => state.dailyReportsObject.offer_voucher_type,

    // Selected Dropdown
    getAggregatorDailyReportSelectedObject: state => state.AggregatordailyReportsObject,
    getAggregatorDailyReportSelectedCinema: state => state.AggregatordailyReportsObject.cinema_name,
    getDailyReportSelectedAggregatorUser: state => state.AggregatordailyReportsObject.username,
    getAggregatorDailyReportSelectedPaymentMode: state => state.AggregatordailyReportsObject.pm_payment_mode,


    // Selected Date
    getAggregatorDailyReportFromDate: state => state.AggregatordailyReportsObject.fromDate,
    getAggregatorDailyReportToDate: state => state.AggregatordailyReportsObject.toDate,

    // Flags
    getAggregatorDailyReportsIsCinema: state => state.flag.isCinema,
    getAggregatorDailyReportsIsExcelDownload: state => state.flag.isExcelDownload,

    // get File name
    getAggregatorDailyExcelFileName: state => state.AggregatordailyExcelFileName,
    getAggregatorDailyPDFFileName: state => state.AggregatordailyPDFFileName,

    // Rendered List
    getAggregatorDailyReportList: state => state.AggregatordailyReportsList,
    getAggregatorDailyRefundList: state => state.AggregatordailyRefundsList,
    getAggregatorDailyConcessionReportList: state => state.AggregatordailyConcessionReportsList,

    // Get Grand Total:
    getAggregatorGrandTotal: state => state.grandTotal,
    getAggregatorBoxOfficeTotal: state => state.boxOfficeTotal,
    getAggregatorConcessionOfficeTotal: state => state.concessionOfficeTotal,

    // GET PAYMENT SUMMARY
    getAggregatorPaymentSummary: state => state.paymentSummary,
    getAggregatorFilmSummary: state => state.filmWiseSummary,
    getAggregatorUserWiseSummary: state => state.UserWiseSummary,
    getAggregatorRefundSummary: state => state.RefundSummary
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AggregatorDailySalesReportStore.js